export default {
  全部交易产品: "모든 거래 상품",
};
